import { GradeNotificationType, UrgentRelationship } from '@gyym/sdk'
import { useGyymClient } from '@gyym/sdk-react'
import { Modal, useModal } from '@gyym/ui'
import { useRouter } from 'next/navigation'
import React from 'react'

import { ProfileForm } from '@/components/Forms/ProfileForm'
import { GyymPassModal } from '@/components/Modals/GyymPassModal'
import { getPrefectureById } from '@/modules/Prefectures'

import { useAuthUser } from './useAuthUser'
import { useIntendedPath } from './useIntendedPath'

export const useInitialProfileRegistrationEffect = () => {
  const {
    authUser,
    isLoggedIn,
    isEmailVerified,
    isProfileRegistered,
    revalidate,
  } = useAuthUser()

  const intended = useIntendedPath()
  const router = useRouter()

  const { openModal } = useModal()
  const client = useGyymClient()

  React.useEffect(() => {
    if (authUser && isLoggedIn && isEmailVerified && !isProfileRegistered) {
      openModal(Modal, {
        title: 'プロフィール登録',
        baseWidth: 500,
        expandOnSmallDevices: true,
        children: (
          <ProfileForm
            onSubmit={async (values) => {
              await client.user.profiles.update(authUser.id, {
                ...values,
                address2: values.address2 ?? '',
                prefecture: getPrefectureById(values.prefecture)!.name,
                urgentRelationship:
                  values.urgentRelationship === UrgentRelationship.OTHER
                    ? values.urgentRelationshipOther
                    : values.urgentRelationship,
              })

              const user = await revalidate()

              if (!user || !user.progress) return

              if (intended) {
                router.push(intended)
                return
              }

              openModal(GyymPassModal, {
                grade: user.progress.currentGrade,
                type: GradeNotificationType.GRADE_UP,
                isAfterProfileUpdate: true,
                disableBackdropClose: false,
              })
            }}
          >
            {({ fields, submit }) => (
              <>
                <Modal.Body>{fields}</Modal.Body>
                <Modal.Footer>{submit}</Modal.Footer>
              </>
            )}
          </ProfileForm>
        ),
      })
    }
  }, [
    authUser,
    client.user.profiles,
    isEmailVerified,
    isLoggedIn,
    router,
    intended,
    isProfileRegistered,
    openModal,
    revalidate,
  ])
}
